import { useQuery } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const GET_ORDER_ID = gql`
  query orderById($input: ID!) {
    order(id: $input) {
      id
    }
  }
`;

export default function useCheckOrder<T>(id: string) {
  return useQuery<T>(GET_ORDER_ID, {
    input: id,
  });
}
